<template>
  <div class="LNBContainer">
    <article ref="LNB" class="LNB">
      <AccordionList />
    </article>
    <!-- <BtmComp /> -->
    <TagNameBalloon />
    <TagConTextMenu />
  </div>
</template>

<script>
export default {
  components : {
    AccordionList : _=> import('@AccordionList') , 
    BtmComp : _=> import('@nav_process/BtmComp') , 
    TagNameBalloon : _=> import('@nav_process/comp/TagNameBalloon') , 
    TagConTextMenu : _=> import('@nav_process/comp/TagConTextMenu') , 
  } , 
  data () {
    return {
      responableStyle : {
        '--width' : '230px' , 
        '--ml' : '16px' , 
      } ,  
    }
  } , 
  mounted () {
  } , 
}
</script>

<style lang="scss" scoped>
  .LNBContainer {
    display: flex; 
    flex-direction: column; 
    position: relative;
    z-index:91;

    .LNB {
      display: flex; 
      flex-direction: column; 
      height: calc( 100% - 128px ); 
      transition: width 0.45s; 
    }
  }
</style>